import React from "react";
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

const Technologygcc = () => {
  return (
    <div className="tabing_section healthcare_tabs_sec p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} className="my-auto">
            <h3 className="h3_head">
              Our Tech Stack for Robust iOS App Development
            </h3>
          </Col>
          <Col xs={12} md={6} lg={6} className="my-auto">
            <p>
              Access the novel toolkit for full-stack iOS application
              development. Combined with proficient iOS app development
              solutions, we help businesses build stellar apps that are
              intuitive at the front-end and extensible at the back-end – which
              also means a quick, high-fidelity MVP with adequate room for
              future scalability.
            </p>
          </Col>
        </Row>
        <Row>
          <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="iOS">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/location_new/uk-mobile/ios_icons/circleci.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>CircleCI</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/location_new/uk-mobile/ios_icons/cocoapods.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>CocoaPods</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/location_new/uk-mobile/ios_icons/objective-C.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Objective-C</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/location_new/uk-mobile/ios_icons/rxswift.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Rxswift</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/location_new/uk-mobile/ios_icons/swiftlint.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Swiftlint</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/location_new/uk-mobile/ios_icons/swiftui.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Swiftui</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="2" title="UI/UX">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/iphone-new/ui-ux/figma.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={70}
                    height={70}
                  />
                  <div className="text_tabs_web">
                    <h6>Figma</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/iphone-new/ui-ux/xd.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={70}
                    height={70}
                  />
                  <div className="text_tabs_web">
                    <h6>Adobe xd</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/iphone-new/ui-ux/InVision_Studio.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={70}
                    height={70}
                  />
                  <div className="text_tabs_web">
                    <h6>InVision Studio</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="3" title="Cloud">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/cloud/aws.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>AWS</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/cloud/azure.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Azure</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/healthcare-new/cloud/google_cloud.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Google Cloud</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="4" title="Backend & Database">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/solution/on-demand-new/database/mongoDB.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>MongoDB</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/solution/on-demand-new/database/mysql.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>MySQL</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/iphone-new/backend-database/Nodejs.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={64}
                    height={72}
                  />
                  <div className="text_tabs_web">
                    <h6>Nodejs</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/iphone-new/backend-database/redis.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={70}
                  />
                  <div className="text_tabs_web">
                    <h6>Redis</h6>
                  </div>
                </li>
              </ul>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </div>
  );
};

export default Technologygcc;
